import {
    HttpEvent,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
    HttpInterceptor
} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';


@Injectable()
export class ErrorIntercept implements HttpInterceptor {
    constructor(
        @Inject(NgxSpinnerService) private spinner: NgxSpinnerService,
        private apiservice: ApiService,
        private router: Router
    ) { }

    errorMessage:any = '';
    displayMessage:any = '';
    private sessionExpiredHandled = false;

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
       return next.handle(request)
            .pipe(
                retry(1),
                catchError((error: HttpErrorResponse) => {

                    // Backend's user.token middleware rejected the session
                    // (expired, invalidated, or not present). Clear local
                    // session and bounce the user to the login screen.
                    if (error.status === 401) {
                        this.spinner.hide();
                        if (!this.sessionExpiredHandled) {
                            this.sessionExpiredHandled = true;
                            localStorage.clear();
                            this.router.navigate(['/home']);
                            setTimeout(() => { this.sessionExpiredHandled = false; }, 2000);
                        }
                        return throwError('Session expired. Please log in again.');
                    }

                    if (error.error instanceof ErrorEvent) {
                        this.errorMessage = `Error: ${error.error.message}`;
                        this.displayMessage = 'Sorry, Something went wrong. Please try again.';
                    } else {
                        this.errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
                        this.displayMessage = 'Sorry, Something went wrong. Please try again.';
                    }

                    localStorage.setItem('loggedUserToken', localStorage.getItem('loggedUserToken'));

                    this.spinner.hide()
                    let errorObj ={
                        error:this.errorMessage
                    }

                    if(this.errorMessage.includes('0 Unknown Error') || this.errorMessage.includes('Unknown Error')){
                    }else{
                        // window.alert(this.displayMessage);
                        this.apiservice.checkClientUniquee(errorObj).subscribe(data => {});
                    }

                    return throwError(this.errorMessage);
                })
            )
    }


}